import { motion } from "framer-motion";
import { Timer } from "lucide-react";
import { Link } from "react-router-dom";
import ScrollReveal from "@/components/3d/ScrollReveal";
import MagneticButton from "@/components/3d/MagneticButton";

const LimitedDropBanner = () => (
  <section className="py-16">
    <div className="container mx-auto px-4">
      <ScrollReveal direction="scale">
        <div className="relative overflow-hidden rounded-3xl border border-primary/20 gradient-purple p-12 text-center sm:p-16">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_20%,hsl(270_20%_4%/0.4)_100%)]" />
          {/* Animated glow orbs */}
          <motion.div
            className="absolute -left-20 -top-20 h-40 w-40 rounded-full bg-accent/30 blur-[80px]"
            animate={{ x: [0, 40, 0], y: [0, 30, 0] }}
            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute -bottom-20 -right-20 h-40 w-40 rounded-full bg-primary/30 blur-[80px]"
            animate={{ x: [0, -40, 0], y: [0, -30, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          />
          <div className="relative">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-background/20 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-primary-foreground backdrop-blur-sm">
              <Timer className="h-3 w-3" /> Limited Edition
            </div>
            <h2 className="font-display text-3xl font-black text-primary-foreground sm:text-5xl">
              Gonvex Gro Gamepad V1
            </h2>
            <p className="mx-auto mt-4 max-w-md text-sm text-primary-foreground/80">
              Exclusive collection. Once it's gone, it's gone. Don't miss your chance to own something rare.
            </p>
            <MagneticButton className="inline-block mt-8" strength={0.25}>
              <Link
                to="/shop"
                className="inline-flex rounded-full bg-background px-8 py-3 font-display text-sm font-semibold text-foreground transition-colors hover:bg-background/90"
              >
                Shop the Drop
              </Link>
            </MagneticButton>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default LimitedDropBanner;
